import { useState } from "react";

const NAV = [
  { label: "首页", href: "#top", active: true },
  { label: "吃瓜热榜", href: "#hot-rank" },
  { label: "热议进行时", href: "#discuss" },
  { label: "舆论风向", href: "#opinion" },
  { label: "瓜田速览", href: "#timeline" },
  { label: "话题广场", href: "#topics" },
];

const TICKER = [
  "综艺收官夜直播画面突发状况，网友火速围观刷屏",
  "某情感调解节目嘉宾言论冲上热搜，评论区两极分化",
  "都市职场剧片尾彩蛋被扒出伏笔，下一季线索引发猜测",
  "网红餐饮连锁回应后厨风波，声明细节遭逐句核实",
  "音乐节主理人深夜道歉，退票与延期方案尚未明确",
  "纪录片导演自曝取材幕后，瓜田第一手素材再添猛料",
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header id="top" className="sticky top-0 z-50 bg-background-50/92 backdrop-blur border-b border-background-200/70">
      {/* 主标识 + 导航 */}
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between gap-4 h-16">
          {/* 品牌 masthead */}
          <a href="#top" className="flex items-center gap-3 shrink-0 group">
            <span className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-accent-600 flex items-center justify-center text-background-50 shadow-none group-hover:scale-105 transition-transform">
              <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
              <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-accent-500 ring-2 ring-background-50 animate-pulse"></span>
            </span>
            <span className="leading-none">
              <span className="block font-display font-black text-2xl tracking-tight text-foreground-950">58<span className="text-primary-600">黑料</span></span>
              <span className="block text-[11px] font-medium text-foreground-500 mt-1">吃瓜围观 · 瓜田速览</span>
            </span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-colors ${
                  item.active
                    ? "bg-secondary-100 text-primary-700 font-semibold"
                    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* 右侧动作 */}
          <div className="flex items-center gap-2">
            <div className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200/70 rounded-full px-3 h-10 w-60">
              <i className="ri-search-line text-foreground-500 text-sm" aria-hidden="true"></i>
              <input
                type="text"
                placeholder="搜瓜、搜话题、搜人名…"
                className="w-full bg-transparent outline-none text-sm placeholder:text-foreground-400"
                aria-label="站内搜索"
              />
            </div>
            <button
              type="button"
              className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 text-sm font-semibold px-4 h-10 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅瓜讯
            </button>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/70 text-foreground-800 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <nav className="md:hidden border-t border-background-200/70 py-3 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className={`px-3 py-2 rounded-lg text-sm ${
                  item.active
                    ? "bg-secondary-100 text-primary-700 font-semibold"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>

      {/* 压顶更新条：今日瓜田实时速递 */}
      <div className="bg-gradient-to-r from-primary-600 via-primary-500 to-accent-600 text-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center gap-4 h-10">
          <span className="shrink-0 flex items-center gap-2 text-[13px] font-bold whitespace-nowrap">
            <i className="ri-broadcast-line animate-pulse" aria-hidden="true"></i>
            <span className="hidden sm:inline">今日瓜田速览</span>
            <span className="sm:hidden">瓜田</span>
          </span>
          <span className="hidden sm:block w-px h-4 bg-background-50/40 shrink-0"></span>
          <div className="flex-1 overflow-hidden ticker-wrap">
            <div className="flex w-max gap-8 ticker-track animate-marquee mask-fade-r">
              {[...TICKER, ...TICKER].map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-[13px] whitespace-nowrap text-background-50/95">
                  <i className="ri-star-smile-line text-[11px]" aria-hidden="true"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <a
            href="#hot-rank"
            className="shrink-0 hidden lg:flex items-center gap-1 text-[12px] font-medium hover:underline whitespace-nowrap cursor-pointer"
          >
            进热榜 <i className="ri-arrow-right-line text-[12px]" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </header>
  );
}